var _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "url(#paint0_linear_5219_2415)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.4169 17.0565C23.1205 14.9977 25.9652 14.9353 26.7993 16.8695L26.8699 17.0577L27.8194 19.8342C28.0369 20.4709 28.3885 21.0536 28.8505 21.5429C29.3124 22.0323 29.8739 22.4168 30.497 22.6707L30.7523 22.766L33.5288 23.7142C35.5877 24.4178 35.65 27.2625 33.7171 28.0966L33.5288 28.1672L30.7523 29.1166C30.1154 29.3341 29.5324 29.6856 29.0429 30.1476C28.5534 30.6095 28.1686 31.171 27.9146 31.7943L27.8194 32.0484L26.8711 34.8261C26.1676 36.885 23.3228 36.9473 22.4899 35.0144L22.4169 34.8261L21.4687 32.0496C21.2513 31.4127 20.8997 30.8297 20.4378 30.3402C19.9759 29.8507 19.4143 29.4659 18.791 29.2119L18.5369 29.1166L15.7604 28.1684C13.7004 27.4649 13.638 24.6201 15.5722 23.7872L15.7604 23.7142L18.5369 22.766C19.1736 22.5484 19.7563 22.1968 20.2456 21.7349C20.735 21.273 21.1195 20.7115 21.3734 20.0883L21.4687 19.8342L22.4169 17.0565ZM34.0559 13C34.276 13 34.4917 13.0617 34.6784 13.1782C34.8652 13.2947 35.0155 13.4612 35.1124 13.6588L35.1688 13.7965L35.5806 15.0036L36.7889 15.4153C37.0094 15.4903 37.2028 15.629 37.3444 15.8139C37.4861 15.9989 37.5696 16.2217 37.5845 16.4542C37.5994 16.6867 37.5449 16.9183 37.4279 17.1198C37.311 17.3213 37.1369 17.4835 36.9277 17.5859L36.7889 17.6424L35.5818 18.0542L35.17 19.2624C35.095 19.4829 34.9561 19.6762 34.7711 19.8177C34.5861 19.9592 34.3632 20.0427 34.1308 20.0574C33.8983 20.0721 33.6667 20.0175 33.4653 19.9005C33.2639 19.7835 33.1017 19.6093 32.9994 19.4001L32.9429 19.2624L32.5312 18.0553L31.3229 17.6436C31.1024 17.5686 30.909 17.4299 30.7674 17.245C30.6257 17.06 30.5422 16.8372 30.5273 16.6047C30.5124 16.3722 30.5669 16.1406 30.6838 15.9391C30.8008 15.7376 30.9749 15.5754 31.1841 15.473L31.3229 15.4165L32.53 15.0047L32.9418 13.7965C33.0211 13.564 33.1712 13.3622 33.371 13.2194C33.5708 13.0766 33.8103 12.9999 34.0559 13Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5219_2415",
    x1: 0,
    y1: 25,
    x2: 50,
    y2: 25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.221933,
    stopColor: "#066094"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3AEBD1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiIcon);
export default __webpack_public_path__ + "static/media/AIIcon.3b5539183fb3212633bb5c354b2c403a.svg";
export { ForwardRef as ReactComponent };